import React from 'react'
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import * as registerActions from '../actions/register';
import * as adminActions from '../actions/admin';
import AuthService from './../utils/authService';

class Header extends React.Component {

    toggleMobileMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        document.body.classList.toggle('show-sidebar');
        const icon = document.querySelector('.nav-toggler i');
        if (icon) {
            const isOpen = document.body.classList.contains('show-sidebar');
            icon.className = isOpen ? 'mdi mdi-close' : 'mdi mdi-menu';
        }
    }

    toggleDesktopSidebar = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const body = document.body;
        const brandSpan = document.querySelector('.navbar-brand span');
        if (body.classList.contains('mini-sidebar')) {
            body.classList.remove('mini-sidebar');
            if (brandSpan) brandSpan.style.display = '';
        } else {
            body.classList.add('mini-sidebar');
            if (brandSpan) brandSpan.style.display = 'none';
        }
    }

    render() {
        let client = AuthService.getClient();

        return (

            <header className="topbar">
                <nav className="navbar top-navbar navbar-expand-md navbar-light">

                    <div className="navbar-header">
                        <a className="navbar-brand" href="\">
                            <span>
                                <img src="/assets/images/Logo_2.png" alt="homepage" className="light-logo" />
                            </span>
                        </a>
                    </div>

                    <div className="navbar-collapse">

                    <ul className="navbar-nav mr-auto mt-md-0">
                        <li className="nav-item"> <button type="button" onClick={this.toggleMobileMenu} onTouchEnd={this.toggleMobileMenu} className="nav-link nav-toggler hidden-md-up text-muted" aria-label="Toggle navigation menu"><i className="mdi mdi-menu"></i></button> </li>
                        <li className="nav-item m-l-10"> <button type="button" onClick={this.toggleDesktopSidebar} className="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark" aria-label="Toggle sidebar"><i className="mdi mdi-menu"></i></button> </li>
                    </ul>

                    <ul className="navbar-nav my-lg-0">
                        
                            <li style={{display: 'flex', alignItems: 'center'}}>
                                <span style={{
                                    background: 'rgba(255,193,7,0.15)',
                                    color: '#FFC107',
                                    fontWeight: 700,
                                    fontSize: '0.78rem',
                                    letterSpacing: '0.06em',
                                    textTransform: 'uppercase',
                                    padding: '4px 12px',
                                    borderRadius: '4px',
                                    border: '1px solid rgba(255,193,7,0.35)',
                                    whiteSpace: 'nowrap'
                                }}>{client}</span>
                            </li>

                        </ul>

                    </div>
                    
                </nav>
            </header>

	
            )
	
    }   

}


function mapStateToProps(state, ownProps) {

    return {
        loggedIn: state.loggedIn,
        loading: state.ajaxCallsInProgress,
        card: state.personnel.card
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({...registerActions, ...adminActions}, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);